import { Box, styled } from '@mui/material'
import Grid from '@mui/material/Grid'
import { DIALOG_BORDER_RADIUS } from '../theme'
import { mobile } from '../utils/breakpoints'

export const PageWrapper = styled(Box)`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.background.default};
  ${({ theme }) => mobile(theme, { 'align-items': 'flex-start', 'padding-top': '5%' })}
`

export const GridPageContainer = styled(Grid)`
  align-items: center;
  justify-content: center;
  max-width: 80%;
  padding-bottom: 120px;
  ${({ theme }) => mobile(theme, { 'max-width': '90%' })}
`

export const GridFormContainer = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const GridItemForm = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  padding: 30px;
  border-radius: ${DIALOG_BORDER_RADIUS};
  text-align: center;
`

export const GridItemImage = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  padding: 0 11%;
  border-radius: ${DIALOG_BORDER_RADIUS};
  ${({ theme }) => mobile(theme, { padding: '20px 50px' })}
`

export const Image = styled('img')`
  width: 100%;
  max-width: 460px;
  height: auto;
  object-fit: contain;
  border-radius: 6px;
`
